import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    id: '', // 学校id 学校特色功能使用 id 判断
    data: { // 学校数据
      // 1 西电 2 北外 3 协和 4 北建筑 5 北航 6 北科 7 西安外事 8 北师大 9 广州医科 10 陕西中医药
      type: '', // 学校展示的类型 通用类型功能使用 type 判断
      auth: '', // 是否需要身份验证
      openid: '', // 用户身份信息
      nickname: '', // 用户昵称
      total: '', // 第几位点亮的
      userTitle: '', // 已经点亮用户的分享标题
      gifTime: '', // gif 图片播放时间 判断是否展示首页 gif 图片
      baseUrl: '', // 所有资源根地址
      title: '', // 分享标题
      desc: '', // 分享描述
      imgUrl: '', // 分享图片
    },
  },
  mutations: {
    setId(state, payload) {
      state.id = payload;
      // 没有类型时，按照id设置
      if (!state.data.type) {
        state.data.type = state.id;
      }
    },
    setDataOpenid(state, payload) {
      state.data.openid = payload;
    },
    setDataNickname(state, payload) {
      state.data.nickname = payload;
    },
    setData(state, payload) {
      state.data = payload;
    },
  },
  actions: {
  },
  modules: {
  },
});
